export default __webpack_public_path__ + "static/media/terms.be98d65a.jpg";